// extracted by mini-css-extract-plugin
export default {"container":"create-video_container__UvVH9","title":"create-video_title__UdLOC"};